import React, {useEffect, useState} from "react";

const NavData = () => {
    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [isProduct, setIsProduct] = useState(false);
    const [isPages, setIsPages] = useState(false);
    const [isNews, setIsNews] = useState(false);
    const [isBlock, setIsBlock] = useState(false);
    const [isBanner, setIsBanner] = useState(false);
    const [isCurrentState, setIsCurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                let id: any = item.getAttribute("sub-items");
                let menusId = document.getElementById(id);
                if (menusId) {
                    (menusId.parentElement as HTMLElement).classList.remove("show");
                }
            });
            e.target.classList.add("active");
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');

        if (isCurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        if (isCurrentState !== 'Product') {
            setIsProduct(false);
        }
        if (isCurrentState !== 'Pages') {
            setIsPages(false);
        }
        if (isCurrentState !== 'News') {
            setIsNews(false);
        }
        if (isCurrentState !== 'Block') {
            setIsBlock(false);
        }
        if (isCurrentState !== 'Banner') {
            setIsBanner(false);
        }
    }, [
        isCurrentState,
        isDashboard,
        isProduct,
        isPages,
        isNews,
        isBlock,
        isBanner,
    ]);

    const menuItems: any = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Dashboards",
            icon: "ph-gauge",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIsCurrentState('Dashboard');
                updateIconSidebar(e);
            },
            stateVariables: isDashboard,
            subItems: [

                {
                    id: "crm",
                    label: "CRM",
                    link: "/dashboard",
                    parentId: "dashboard",
                },
            ],
        },
        {
            label: "Product",
            isHeader: true,
        },
        {
            id: "category-list",
            label: "Category",
            icon: "ph-calendar",
            link: "/category-list",
        },
        {
            id: "brand-list",
            label: "Brands",
            icon: "bi bi-layers",
            link: "/brand-list",
        },
        {
            id: "colors-list",
            label: "Colors",
            icon: "ph-paint-brush-broad",
            link: "/colors-list",
        },
        {
            id: "attributes",
            label: "Attributes",
            icon: "ph-calendar",
            link: "/attributes-list",
        },
        {
            id: "models",
            label: "Models",
            icon: "ph-bandaids",
            link: "/models-list",
        },
        {
            id: "discount",
            label: "Discount",
            icon: "ph-ticket",
            link: "/discounts-list",
        },
        {
            id: "subMenu",
            label: "SubMenu",
            icon: "ph-file-text",
            link: "/sub-menu",
        },
        {
            id: "homeLayout",
            label: "Collection",
            icon: "ph-paint-brush-broad",
            link: "/home-layout",
        },
        {
            id: "badge",
            label: "Badge",
            icon: "ph-chart-pie-slice",
            link: "/badge",
        },
        {
            id: "product",
            label: "Product",
            icon: "ph-storefront",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsProduct(!isProduct);
                setIsCurrentState('Product');
                updateIconSidebar(e);
            },
            stateVariables: isProduct,
            subItems: [
                {id: 1, label: "Products", link: "/products", parentId: "product"},
                {id: 2, label: "Product Grid", link: "/product-grid", parentId: "product"},
                // {id: 2, label: "Product Details", link: "/product-details", parentId: "product"},
                {id: 3, label: "Create Product", link: "/create-product", parentId: "product"},
                // {id: 6, label: "Customers", link: "/customers", parentId: "product"},
            ],
        },

        {
            label: "Pages",
            isHeader: true,
        },

        {
            id: "banner",
            label: "Banner",
            icon: "ph-keyboard-thin",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsBanner(!isBanner);
                setIsCurrentState('Banner');
                updateIconSidebar(e);
            },
            stateVariables: isBanner,
            subItems: [
                {
                    id: "bannerMain",
                    label: "Bannerlar",
                    link: "/banner-slider",
                    parentId: "banner"
                },
            ]
        },
        {
            id: "news",
            label: "News",
            icon: "ph-table",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsNews(!isNews);
                setIsCurrentState('News');
                updateIconSidebar(e);
            },
            stateVariables: isNews,
            subItems: [
                {
                    id: "News",
                    label: "News",
                    link: "/news-list",
                    parentId: "news"
                },
                {
                    id: "CreateNews",
                    label: "Create News",
                    link: "/create-news",
                    parentId: "news"
                },
            ]
        },
        {
            id: "block",
            label: "Block",
            icon: "ph-credit-card-thin",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsBlock(!isBlock);
                setIsCurrentState('Block');
                updateIconSidebar(e);
            },
            stateVariables: isBlock,
            subItems: [
                {
                    id: "Block",
                    label: "Block",
                    link: "/blocks",
                    parentId: "block"
                },
                {
                    id: "createBlock",
                    label: "Create Block",
                    link: "/create-block",
                    parentId: "block"
                },
            ]
        },
        {
            id: "page",
            label: "Pages",
            icon: "ph-chart-pie-slice",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsPages(!isPages);
                setIsCurrentState('Pages');
                updateIconSidebar(e);
            },
            stateVariables: isPages,
            subItems: [
                {
                    id: "Pages",
                    label: "Pages",
                    link: "/Pages",
                    parentId: "page"
                },
                {
                    id: "createPages",
                    label: "Create Pages",
                    link: "/create-Page",
                    parentId: "page"
                },
            ]
        },

        {
            id: "profile",
            label: "Profile",
            icon: "ph-user-circle-thin",
            link: "/user-profile",
        },
        {
            id: "discountBanner",
            label: "Discount Banner",
            icon: "ph-square-half-thin",
            link: "/discount-banner",
        },
        {
            id: "logOut",
            label: "Log out",
            icon: "mdi mdi-logout",
            link: "/logout",
        },
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default NavData;